import {
    FETCH_COMPANY_ORDERS,
    NOTIFY_ON_ORDER_ARRIVAL
} from '../types';
import api from '../api';

export const fetchCompanyOrders = (companyId) => {
    return {
        type: FETCH_COMPANY_ORDERS,
        payload: api.company.get(companyId).orders.getAll(),
    };
};

export const notifyOnOrderArrival = (companyId, orderId) => {
    return {
        type: NOTIFY_ON_ORDER_ARRIVAL,
        payload: api.company.get(companyId).orders.notify(orderId),
        meta: { toastSuccess: true }
    };
};
